"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _skyplanes = _interopRequireDefault(require("@decisiv/design-tokens/lib/skyplanes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _default = function _default() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var plane;

  if (typeof item === 'string') {
    plane = _skyplanes.default.alias[item];
  } else {
    plane = _skyplanes.default.scale[item];
  }

  if (!plane) {
    return '';
  }

  var _plane = plane,
      xOffset = _plane.xOffset,
      yOffset = _plane.yOffset,
      size = _plane.size,
      color = _plane.color,
      opacity = _plane.opacity;
  return "".concat(xOffset, "px ").concat(yOffset, "px ").concat(size, "px ").concat((0, _toColorString.default)(_objectSpread({}, color, {
    alpha: opacity
  })));
};

exports.default = _default;